import { LocalBusinessJsonLd } from 'next-seo'
import { stripHtml } from '@/utils/htmlUtils'
import { BRAND_NAME } from '@/utils/constants'

const OrganizationSD = ({ footerSettings }) => {
  const logo = footerSettings?.logo?.asset?.url || ''
  const businessName = footerSettings?.title || BRAND_NAME
  const domain = process.env.NEXT_PUBLIC_DOMAIN || 'https://sitkaseafoodmarket.com'
  const telephoneCandidate = footerSettings?.phoneNumber || footerSettings?.contactPhone
  const telephone =
    (typeof telephoneCandidate === 'string' && telephoneCandidate.trim()) || '+1-309-342-3474'
  const rawDescription = footerSettings?.footerProps
  const descriptionCandidate =
    typeof rawDescription === 'string' ? stripHtml(rawDescription).trim() : ''
  const description =
    descriptionCandidate ||
    `${BRAND_NAME} delivers wild-caught Alaskan seafood to members across the United States.`

  const socialLinks =
    footerSettings?.socialLinks
      ?.map((link) => link?.socialLink)
      .filter(Boolean) || [
      'https://www.facebook.com/SitkaSeafoodMarket',
      'https://www.instagram.com/sitkaseafoodmarket',
      'https://www.youtube.com/c/SitkaSalmonShares',
      'https://www.pinterest.com/sitkaseafoodmarket',
    ]

  return (
    <LocalBusinessJsonLd
      type="LocalBusiness"
      id={`${domain}/#localbusiness`}
      name={businessName}
      description={description}
      url={domain}
      logo={logo}
      telephone={telephone}
      address={{
        streetAddress: '216 Smith St',
        addressLocality: 'Sitka',
        addressRegion: 'AK',
        postalCode: '99835',
        addressCountry: 'US',
      }}
      geo={{
        latitude: '43.09479769778319',
        longitude: '-89.33408142728253',
      }}
      sameAs={socialLinks}
      contactPoint={[
        {
          contactType: 'customer service',
          telephone,
          areaServed: 'US',
          availableLanguage: ['English'],
        },
      ]}
    />
  )
}

export default OrganizationSD
